"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.873 4.046C11.213 3.404 11.928 3 12.68 3c.75 0 1.466.404 1.806 1.046a2.011 2.011 0 0 1 2.819 1.672q.293-.096.617-.097c1.11 0 2.01.9 2.01 2.01v7.427A5.94 5.94 0 0 1 13.99 21h-1.563a5.94 5.94 0 0 1-4.943-2.646l-3.069-4.602a2.058 2.058 0 0 1 3.167-2.597l.466.466V5.884a2.01 2.01 0 0 1 2.826-1.838m-.205 1.842v-.004a.611.611 0 0 0-1.22 0v7.426a.7.7 0 0 1-1.196.495l-1.66-1.66a.658.658 0 0 0-1.013.83l3.068 4.602a4.54 4.54 0 0 0 3.78 2.023h1.562a4.54 4.54 0 0 0 4.543-4.542V7.632a.611.611 0 0 0-1.221 0v3.931a.7.7 0 1 1-1.4 0V5.884a.611.611 0 0 0-1.222-.003v5.682a.7.7 0 1 1-1.4 0V4.88c0-.196-.202-.479-.61-.479s-.61.283-.61.48v6.683a.7.7 0 1 1-1.4 0z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HandIcon24.js.map